import React from "react";

const ThreeDotsIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9993 17.3307C16.7357 17.3307 17.3327 16.7338 17.3327 15.9974C17.3327 15.261 16.7357 14.6641 15.9993 14.6641C15.263 14.6641 14.666 15.261 14.666 15.9974C14.666 16.7338 15.263 17.3307 15.9993 17.3307Z"
        stroke="#0A012E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3333 17.3307C26.0697 17.3307 26.6667 16.7338 26.6667 15.9974C26.6667 15.261 26.0697 14.6641 25.3333 14.6641C24.597 14.6641 24 15.261 24 15.9974C24 16.7338 24.597 17.3307 25.3333 17.3307Z"
        stroke="#0A012E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66732 17.3307C7.4037 17.3307 8.00065 16.7338 8.00065 15.9974C8.00065 15.261 7.4037 14.6641 6.66732 14.6641C5.93094 14.6641 5.33398 15.261 5.33398 15.9974C5.33398 16.7338 5.93094 17.3307 6.66732 17.3307Z"
        stroke="#0A012E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ThreeDotsIcon;
